export const SIDEBAR_STORAGE_KEY = "ai_platform_trainer_sidebar";
export const LANGUAGE_STORAGE_KEY = "ai_platform_trainer_language";
export const TOKEN_STORAGE_KEY = "ai_platform_trainer_token";
export const USER_STORAGE_KEY = "ai_platform_trainer_user";
